/**
 * Utility functions for domain-based language detection
 */

export const getDomainLanguage = (): string => {
  if (typeof window === 'undefined') {
    return 'en'; // Default for SSR
  }

  const hostname = window.location.hostname;
  
  // Check if the domain contains 'LuxBox.cn' or ends with '.cn'
  if (hostname.includes('LuxBox.cn') || hostname.endsWith('.cn')) {
    return 'cn';
  }
  
  // Default to English for all other domains (including luxbox.ai)
  return 'en';
};

export const getDocumentTitle = (language: string): string => {
  return language === 'cn' ? '光影立方' : 'LuxBox';
};

export const setDocumentTitle = (language: string): void => {
  if (typeof document !== 'undefined') {
    document.title = getDocumentTitle(language);
  }
}; 